export default __webpack_public_path__ + "static/media/1.ab4dc20f.png";